import { Status } from "./Status";


export class OuterCubeStatusSmartEnum {
    static Packed = new Status("Packed", 1, "pill--green");
    static Disposed = new Status("Disposed", 2, "pill--red");
    static Disposing = new Status("Disposing", 3, "pill--orange");
    static Created = new Status("Created", 5, "pill--grey");
    static Recalled = new Status("Recalled", 5, "pill--blue");

    public static getName() {
        // Cannot use this.name as it will be the minified value in production
        return "OuterCubeStatusSmartEnum";
    }
}
